import angular from 'angular';
import FileCardComponent from './file-card-component';

export default angular
   .module('file-card', [])
   .component('fileCard', FileCardComponent);



// WEBPACK FOOTER //
// ./src/modules/utils/file-card/file-card-module.js